"use client";

import { createContext, useContext, type ReactNode } from "react";

const AffiliateWebhookContext = createContext(false);

export default function AffiliateWebhookProvider({
  enabled = false,
  children,
}: {
  enabled?: boolean;
  children: ReactNode;
}) {
  return (
    <AffiliateWebhookContext.Provider value={enabled}>
      {children}
    </AffiliateWebhookContext.Provider>
  );
}

export function useAffiliateWebhook(): boolean {
  return useContext(AffiliateWebhookContext);
}
